// Test IDs for CoSec Global home page
export const HID = {
  // Header
  headerLogo: "cosec-header-logo",
  navSolutions: "cosec-nav-solutions",
  navFeatures: "cosec-nav-features",
  navSecurity: "cosec-nav-security",
  navFaqs: "cosec-nav-faqs",
  navProducts: "cosec-nav-products",
  navProductCosecApp: "cosec-nav-product-cosec-app",
  navProductCoverify: "cosec-nav-product-coverify",
  navProductCosearch: "cosec-nav-product-cosearch",
  navBookDemo: "cosec-nav-book-demo",
  mobileToggle: "cosec-mobile-toggle",
  // Hero
  heroBookDemo: "hero-book-demo",
  heroSeeProducts: "hero-see-products",
  // Personas
  personaCoSec: "home-persona-cosec",
  personaAccountants: "home-persona-accountants",
  personaLegal: "home-persona-legal",
  // Section CTAs
  ctaRecords: "cta-records-book-demo",
  ctaCompliance: "cta-compliance-see-how",
  ctaGovernance: "cta-governance-book-demo",
  ctaSecurity: "cta-security-learn-more",
  // Testimonials
  testimonialPrev: "testimonial-prev",
  testimonialNext: "testimonial-next",
  testimonialItem: (i) => `testimonial-item-${i}`,
  // FAQ
  faqItem: (i) => `cosec-faq-item-${i}`,
  // Final
  finalBookDemo: "final-book-demo",
  // Footer
  footerLogo: "cosec-footer-logo",
  footerCoverifyLink: "cosec-footer-coverify-link",
  footerContact: "cosec-footer-contact",
};
